export const DELIVERY_COND_LIST = 'DELIVERY_COND_LIST';
export const DELIVERY_COND_ADD_SUCCESS = 'DELIVERY_COND_ADD_SUCCESS';
export const DELIVERY_COND_EDIT_SUCCESS = 'DELIVERY_COND_EDIT_SUCCESS';
export const DELIVERY_COND_CRUD = 'DELIVERY_COND_CRUD';
export const TOGGLE_VIEW_EDIT = 'TOGGLE_VIEW_EDIT';
export const DEL_COND_LOADER = 'DEL_COND_LOADER';
export const DELIVERY_COND_DELETE='DELIVERY_COND_DELETE';
